import React, { useEffect } from 'react';
import "./App.css";
import { useState } from 'react'; 
import { Home, Video, Users, BookOpen, Dog } from 'lucide-react';
import Calendar from "react-calendar";





const Header = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    
    useEffect(() => {
      let lastScrollTop = 0;
      let ticking = false;
  
      const handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
        if (!ticking) {
          window.requestAnimationFrame(() => {
            if (scrollTop > 50 && scrollTop > lastScrollTop) {
              setIsCollapsed(true);
            } else {
              setIsCollapsed(false);
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            ticking = false;
          });
  
          ticking = true;
        }
      };
  
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    return (
      <header className={`header ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="logo">Canine Hub</div>
        <button className="mobile-menu-button" onClick={toggleMobileMenu}>
          <i className="fas fa-bars"></i>
        </button>
        <nav className={isMobileMenuOpen ? 'mobile-menu-open' : ''}>
          <ul>
            <li><a href="#services" onClick={() => setIsMobileMenuOpen(false)}>Services</a></li>
            <li><a href="#team" onClick={() => setIsMobileMenuOpen(false)}>Team</a></li>
            <li><a href="#blog" onClick={() => setIsMobileMenuOpen(false)}>Blog</a></li>
            <li><a href="#testimonials" onClick={() => setIsMobileMenuOpen(false)}>Testimonials</a></li>
            <li><a href="#contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a></li>
          </ul>
        </nav>
      </header>
    );
  };
  
  
  
  
  
  
  const CalendarComponent = () => {
    const [bookedDates, setBookedDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
  
    const fetchBookedDates = async (start, end) => {
      console.log("Fetching booked dates:", {
        timeMin: start.toISOString(),
        timeMax: end.toISOString(),
      });
  
      setLoading(true);
      setError(null);
  
      try {
        const timeMin = start.toISOString();
        const timeMax = end.toISOString();
  
        const backendUri = process.env.REACT_APP_BACKEND_URI; // Ensure BACKEND_URI is set in your environment variables

        const response = await fetch(`${backendUri}/events`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ timeMin, timeMax }),
          timeout: 10000, // 10-second timeout
        });

        console.log("Response status:", response.status);
  
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Server error response:", errorText);
          throw new Error(`Failed to fetch booked dates: ${errorText}`);
        }
  
        const data = await response.json();
        console.log("Received events:", data);
  
        // Extract booked dates
        const validDates = data.map((event) => new Date(event.start?.dateTime || event.start?.date));
        setBookedDates(validDates);
      } catch (error) {
        console.error("Error fetching booked dates:", error);
        setError(error.message);
        setBookedDates([]);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      const lastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
      fetchBookedDates(firstDay, lastDay);
    }, []);
  
    return (
      <div>
        {loading && <p>Loading booked dates...</p>}
        {error && <p style={{ color: "red" }}>Error: {error}</p>}
  
        <Calendar
          tileClassName={({ date, view }) => {
            if (view === "month") {
              // Check if the date is booked
              const isBooked = bookedDates.some(
                (bookedDate) => bookedDate.toDateString() === date.toDateString()
              );
              if (isBooked) {
                return "react-calendar__tile--hasActive";
              }
            }
            return "";
          }}
          tileDisabled={({ date, view }) => {
            if (view === "month") {
              // Disable the tile if the date is booked
              return bookedDates.some(
                (bookedDate) => bookedDate.toDateString() === date.toDateString()
              );
            }
            return false;
          }}
        />
  
        <button
          style={{
            backgroundColor: "#8a70ff",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "20px",
          }}
          onClick={() =>
            window.open(
              "https://wa.me/your-phone-number",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          Book A Slot with Us Now!
        </button>
      </div>
    );
  };
  
  

  
  const ConsultationModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>×</button>
                <h2>Schedule a Consultation</h2>
                <CalendarComponent />
            </div>
        </div>
    );
};

const HeroSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openConsultationModal = () => {
        setIsModalOpen(true);
    };

    const closeConsultationModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <section id="hero" className="hero-component">
                <div className="hero-content">
                    <div className="hero-text-content">
                        <h1 className="hero-title">
                            Training That Makes Life Easier
                            <span className="title-accent">For You and Your Dog.</span>
                        </h1>
                        <p className="tagline">Transform Your Dog's Potential with Expert Training</p>
                        <div className="hero-description">
                            <p className="main-text">
                                At Canine Hub, I apply proven, science-backed methods to bring out the best in every dog I train. With structured, expert-led programs, I ensure lasting behaviour transformation—not temporary fixes.
                            </p>
                            <div className="features">
                                <div className="feature-item">
                                    <span className="feature-icon">•</span>
                                    <span>Research-Based Training Methods</span>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">•</span>
                                    <span>Certified Professional Trainer</span>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">•</span>
                                    <span>Customized Development Plans</span>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">•</span>
                                    <span>Proven Track Record of Success</span>
                                </div>
                            </div>
                            <button 
                                className="cta-button" 
                                onClick={openConsultationModal}
                            >
                                Schedule a Consultation
                            </button>
                        </div>
                    </div>
                    <div className="hero-image-wrapper">
                        <img 
                            src="/images/goldenpuppy.png" 
                            alt="Professional Dog Training" 
                            className="dog-image" 
                        />
                    </div>
                </div>
            </section>

            <ConsultationModal 
                isOpen={isModalOpen} 
                onClose={closeConsultationModal} 
            />
        </>
    );
};



const ServicesWithImages = () => {
  return (
    <section className="services-section">
      <div className="services-content">
        <h2 className="services-title">Our Services</h2>
        <p className="services-subtitle">Comprehensive Training Solutions for Every Need</p>
        
        <div className="services-grid">
          <div className="service-card">
            <h3>1. Board & Train Program</h3>
            <h4>Intensive, structured training with daily practice and routine.</h4>
            <p>Your dog stays with me in a controlled environment where I work on obedience, manners, leash walking, confidence building, and specific behaviour issues. Ideal for busy owners or dogs needing focused, consistent training.</p>
          </div>

          <div className="service-card">
            <h3>2. One-on-One Home Training</h3>
            <h4>Personalised sessions at your home with hands-on coaching.</h4>
            <p>I guide both you and your dog through customized training plans covering obedience, recall, leash control, socialisation, and problem behaviours—designed to fit your routine and lifestyle.</p>
          </div>

          <div className="service-card">
            <h3>3. Puppy Training Program</h3>
            <h4>Build the perfect foundation from Day 1.</h4>
            <p>Covers toilet training, biting, socialisation, crate training, name recall, engagement, and essential puppy manners to prevent future behaviour issues.</p>
          </div>

          <div className="service-card">
            <h3>4. Behavioural Correction</h3>
            <h4>Targeted training for issues like barking, reactivity, anxiety, or aggression.</h4>
            <p>I assess the root cause and create a clear, structured plan to reshape your dog's behaviour and help you manage situations confidently.</p>
          </div>

          <div className="service-card">
            <h3>5. Group Training Classes</h3>
            <h4>Social learning in a controlled, distraction-based environment.</h4>
            <p>Great for building confidence, improving recall around distractions, and polishing obedience with other dogs and people around.</p>
          </div>

          <div className="service-card">
            <h3>6. Online Consultations</h3>
            <h4>Expert guidance for both obedience training and behaviour correction—no matter where you are.</h4>
            <p>I provide structured, step-by-step solutions for issues like leash pulling, recall, puppy biting, barking, anxiety, reactivity, and more. Each session includes personalised assessments, training plans, and follow-ups to ensure steady progress at home.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

const VideoArea = () => {
  const videoRef = React.useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      });
    }, options);

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <section className="video-area">
      <div className="video-content">
        <div className="video-text">
          <h2>Training Insights</h2>
          <p className="video-subtitle">Watch how we transform behaviors through positive reinforcement</p>
          <div className="video-features">
            <div className="video-feature">
              <i className="fas fa-check-circle"></i>
              <span>Real Training Sessions</span>
            </div>
            <div className="video-feature">
              <i className="fas fa-check-circle"></i>
              <span>Proven Techniques</span>
            </div>
            <div className="video-feature">
              <i className="fas fa-check-circle"></i>
              <span>Visible Results</span>
            </div>
          </div>
        </div>
        <div className="video-wrapper">
          <video 
            ref={videoRef}
            controls 
            muted
            playsInline
            poster="/images/video-thumbnail.jpg"
          >
            <source src="/videos/adiblog1.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
};

const TeamShowcase = () => {
    return (
      <section id="team" className="team-showcase">
        <div className="team-header">
          <h1>Meet our team!</h1>
        </div>
        <div className="team-cards">
          <div className="team-member left">
          <img src="/images/aditya_pfp.png" alt="Aditya" className="team-image" />
            <div className="team-details">
              <h3>Aditya</h3>
              <h2>Founder and Head Trainer</h2>
              <p>Certified Dog Trainer and behaviorist.</p>
            </div>
          </div>
         
        </div>
      </section>
    );
  };
  
  
const BlogSection = () => {
  return (
    <section id="blog" className="blog-section">
      <div className="blog-content">
        <div className="blog-header">
          <h2 className="blog-title">Latest from Our Blog</h2>
          <p className="blog-subtitle">Insights and Tips from Professional Trainers</p>
        </div>
        
        <div className="blog-grid">
          <article className="blog-card">
            <div className="blog-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                alt="Dog Training" 
                className="blog-image"
              />
            </div>
            <div className="blog-text">
              <div className="blog-meta">
                <span className="blog-date">March 15, 2024</span>
                <span className="blog-category">Training Tips</span>
              </div>
              <h3>Understanding Your Dog's Body Language</h3>
              <p>Dogs communicate primarily through body language. Learning to read these subtle cues can dramatically improve your relationship with your pet. In this comprehensive guide, we'll explore the key signals...</p>
              <a href="#blog" className="blog-read-more">Read More →</a>
            </div>
          </article>

          <article className="blog-card">
            <div className="blog-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1601758228041-f3b2795255f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                alt="Puppy Training" 
                className="blog-image"
              />
            </div>
            <div className="blog-text">
              <div className="blog-meta">
                <span className="blog-date">March 10, 2024</span>
                <span className="blog-category">Puppy Care</span>
              </div>
              <h3>Essential Puppy Training Techniques</h3>
              <p>Starting your puppy's training journey on the right foot is crucial for their development. Here are the proven methods we use at our training center to establish good behaviors from day one...</p>
              <a href="#blog" className="blog-read-more">Read More →</a>
            </div>
          </article>

          <article className="blog-card">
            <div className="blog-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1534361960057-19889db9621e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                alt="Dog Socialization" 
                className="blog-image"
              />
            </div>
            <div className="blog-text">
              <div className="blog-meta">
                <span className="blog-date">March 5, 2024</span>
                <span className="blog-category">Behavior</span>
              </div>
              <h3>The Importance of Early Socialization</h3>
              <p>Proper socialization during your dog's formative weeks is essential for developing a well-adjusted adult dog. Learn about the critical periods and how to make the most of them...</p>
              <a href="#blog" className="blog-read-more">Read More →</a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-content">
        <div className="testimonials-header">
          <h2 className="testimonials-title">What Pet Parents Say</h2>
          <p className="testimonials-subtitle">Real Stories from Our Community</p>
        </div>
        
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <div className="testimonial-quote">"</div>
            <p className="testimonial-text">
              Aditya transformed our dog's behavior in just a few weeks! His understanding of canine psychology and patient approach made all the difference.
            </p>
            <div className="testimonial-author">
              <img src="https://via.placeholder.com/60" alt="Client" className="author-image" />
              <div className="author-details">
                <h4>Sarah Mitchell</h4>
                <p>Parent of Max, Golden Retriever</p>
              </div>
            </div>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-quote">"</div>
            <p className="testimonial-text">
              The group socialization sessions were exactly what our shy puppy needed. Now she confidently plays with other dogs and has made great progress!
            </p>
            <div className="testimonial-author">
              <img src="https://via.placeholder.com/60" alt="Client" className="author-image" />
              <div className="author-details">
                <h4>Michael Brown</h4>
                <p>Parent of Luna, Border Collie</p>
              </div>
            </div>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-quote">"</div>
            <p className="testimonial-text">
              The online training sessions were incredibly convenient and effective. Aditya's expertise shines through even in virtual consultations.
            </p>
            <div className="testimonial-author">
              <img src="https://via.placeholder.com/60" alt="Client" className="author-image" />
              <div className="author-details">
                <h4>Emily Zhang</h4>
                <p>Parent of Buddy, Labrador Mix</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};



const Slideshow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slideData = [
    { 
      url: '/images/image1.jpg', 
      caption: 'Professional Training Sessions',
      description: 'Personalized attention for every dog'
    },
    { 
      url: '/images/image2.jpg', 
      caption: 'Group Training Classes',
      description: 'Socialization in a controlled environment'
    },
    { 
      url: '/images/image3.jpg', 
      caption: 'Behavior Modification',
      description: 'Transform challenging behaviors with proven methods'
    }
  ];

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slideData.length);
  };

  const goToPreviousSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slideData.length) % slideData.length);
  };

  useEffect(() => {
    const timer = setInterval(goToNextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="slideshow-section">
      <div className="slideshow-container">
        {slideData.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.url})` }}
          >
            <div className="slide-content">
              <h2>{slide.caption}</h2>
              <p>{slide.description}</p>
            </div>
          </div>
        ))}

        <button className="slide-nav prev" onClick={goToPreviousSlide}>
          <i className="fas fa-chevron-left"></i>
        </button>
        <button className="slide-nav next" onClick={goToNextSlide}>
          <i className="fas fa-chevron-right"></i>
        </button>

        <div className="slide-indicators">
          {slideData.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
};





const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3><i className="fas fa-paw"></i> Canine Hub</h3>
          <p>Professional dog training services tailored to your pet's needs.</p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/caninehub_?igsh=MXVsczRicDI2a2htYQ%3D%3D" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4><i className="fas fa-link"></i> Quick Links</h4>
          <ul>
            <li><i className="fas fa-angle-right"></i> <a href="#services">Services</a></li>
            <li><i className="fas fa-angle-right"></i> <a href="#team">Our Team</a></li>
            <li><i className="fas fa-angle-right"></i> <a href="#blog">Blog</a></li>
            <li><i className="fas fa-angle-right"></i> <a href="#testimonials">Testimonials</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4><i className="fas fa-address-card"></i> Contact Us</h4>
          <ul className="contact-info">
            <li>
              <i className="fas fa-envelope"></i>
              <a href="mailto:aditya@caninehub.com">aditya@caninehub.com</a>
            </li>
            <li>
              <i className="fas fa-phone"></i>
              <a href="tel:+1234567890">+91 9611188219</a>
            </li>
            <li>
              <i className="fas fa-map-marker-alt"></i>
              <span>Bangalore, Karnataka</span>
            </li>
            <li>
              <i className="far fa-clock"></i>
              <span>Mon - Sat: 9:00 AM - 6:00 PM</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p><i className="far fa-copyright"></i> 2024 Canine Hub. All rights reserved.</p>
      </div>
    </footer>
  );
};

const App = () => {
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const sections = document.querySelectorAll('section');
    sections.forEach(section => {
      observer.observe(section);
      
      const animatedElements = section.querySelectorAll('.service-card, .team-member, .blog-card, .testimonial-card');
      animatedElements.forEach(element => {
        observer.observe(element);
      });
    });

    return () => observer.disconnect();
  }, []);






  

  return (
   
    <div>
      <Header />
      <HeroSection />
      <ServicesWithImages />
      <VideoArea />
      <TeamShowcase />
      <BlogSection />
      <Testimonials />
      <Slideshow />
      <Footer />

    </div>
  );
};

export default App;
